import React, { useEffect } from "react";
import { Form, Input, Button, Row, Col, Spin } from "antd";
import { ReactSVG } from "react-svg";

const CompanyAdminsFilterForm = ({ isFetching, query, onSubmit }) => {
  const [form] = Form.useForm();

  const nameField = "name";
  const nameValue = query[nameField];

  const emailField = "email";
  const emailValue = query[emailField];

  useEffect(() => {
    form.setFieldsValue(initialValues());
  }, [query]);

  const initialValues = () => {
    const values = {};
    values[nameField] = nameValue;
    values[emailField] = emailValue;
    return values;
  };

  const handleSubmit = values => {
    const params = {};
    params[nameField] = values[nameField] || null;
    params[emailField] = values[emailField] || null;
    onSubmit({ ...query, ...params, currentPage: 1 }, true);
  };

  const handleResetButton = () => {
    onSubmit({}, true);
    form.resetFields();
  };

  return (
    <Spin spinning={isFetching}>
      <Form
        form={form}
        onFinish={handleSubmit}
        initialValues={initialValues}
        className="FilterForm CompanyAdminsFilterForm"
        layout="vertical">
        <div className="FilterFormContent">
          <Row gutter={16}>
            <Col xs={{ span: 24 }} md={{ span: 8 }}>
              <Form.Item label="Name" name={nameField}>
                <Input size="large" placeholder="Name" />
              </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} md={{ span: 8 }}>
              <Form.Item label="Email" name={emailField}>
                <Input size="large" placeholder="Email" />
              </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} md={{ span: 8 }}>
              <div className="FilterFormActions">
                <Button size="large" type="text" onClick={handleResetButton}>
                  Reset
                  <ReactSVG className="icon" src="/icons/reset.svg" />
                </Button>
                <Button size="large" type="primary" htmlType="submit">
                  Apply
                  <ReactSVG className="icon" src="/icons/apply.svg" />
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      </Form>
    </Spin>
  );
};

export default CompanyAdminsFilterForm;
